import { useQuery, useQueryClient } from "@tanstack/react-query"
import {
  getAllCuentasBancarias,
  getCuentaBancariaById,
} from "./CuentaBancaria.service"

export function useCuentaBancariaTesoreriaById(id?: string) {
  const queryClient = useQueryClient()

  const {
    data: cuentaBancariaById,
    isLoading: cuentaBancariaByIdIsLoading,
    error: cuentaBancariaByIdError,
    refetch: cuentaBancariaByIdRefetch,
    isFetching: cuentaBancariaByIdIsFetching,
  } = useQuery({
    queryKey: ["getCuentaBancariaById", id],
    queryFn: () => (id ? getCuentaBancariaById(id) : Promise.resolve(null)),
    refetchOnWindowFocus: false,
    retry: false,
  })

  const invalidateCuentaBancariaById = ({ id }: { id?: string }) =>
    queryClient.invalidateQueries({ queryKey: ["getCuentaBancariaById", id] })

  return {
    cuentaBancariaById,
    cuentaBancariaByIdIsLoading,
    cuentaBancariaByIdError,
    invalidateCuentaBancariaById,
    cuentaBancariaByIdRefetch,
    cuentaBancariaByIdIsFetching,
  }
}

export function useCuentasBancariasAll({
  isRefetchOnMount = false,
}: {
  isRefetchOnMount?: boolean | "always"
}) {
  const queryClient = useQueryClient()

  const {
    data: cuentaBancariaAll,
    isLoading: cuentaBancariaAllIsLoading,
    error: cuentaBancariaAllError,
    refetch: cuentaBancariaAllRefetch,
    isFetching: cuentaBancariaAllIsFetching,
  } = useQuery({
    queryKey: ["getCuentaBancariaAll"],
    queryFn: () => getAllCuentasBancarias(),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000 * 60 * 20,
    refetchOnMount: isRefetchOnMount,
  })

  const invalidateCuentaBancariaAll = () =>
    queryClient.invalidateQueries({ queryKey: ["getCuentaBancariaAll"] })

  return {
    cuentaBancariaAll,
    cuentaBancariaAllIsLoading,
    cuentaBancariaAllError,
    invalidateCuentaBancariaAll,
    cuentaBancariaAllRefetch,
    cuentaBancariaAllIsFetching,
  }
}
